<template>
  <ServiceCard 
    title="AWS DevOps"
    subtitle="Streamline your deployment pipeline"
    description="Implement CI/CD pipelines, infrastructure as code, and automated deployment strategies for faster delivery."
    to="/services/aws-devops"
    gradient-start="#667eea"
    gradient-end="#764ba2"
    button-text="Learn More"
  />
</template>

<script setup>
import ServiceCard from '~/components/ServiceCard.vue';
</script>